import { useUser } from "$global-providers/user-provider";
import { useMemo } from "react";

/**
 * Wraps a component and conditionally renders it
 * if the user's role is one of the provided roles
 *
 * HOC used instead of a component with a `children` prop to avoid
 * the parent component "rendering" the children first,
 * only for this component to return null
 *
 * Example:
 * const Component = props => <div>Sensitive stuff</div>;
 * const PrivateComponent = privateGuard([ADMIN, CLINIC])(Component);
 * @deprecated: Use <RequireAuth> instead.
 */
const privateGuard = (roles) => (Component) => (props) => {
  const { role } = useUser();
  const isAuthorised = useMemo(
    () => roles?.includes(role) ?? true,
    [role, roles?.includes],
  );

  if (isAuthorised) {
    return <Component {...props} />;
  }

  return null;
};

export default privateGuard;
